import * as React from 'react';
import { ChangeEvent, useState } from 'react';
import { createStyles, FormControl, makeStyles, MenuItem, Select } from '@material-ui/core';
import DownGradeToFreePlanModal from 'components/backorder/modal/DownGradeToFreePlanModal';
import styled from 'styled-components';
import { BackOrderSubscriptionType, ClosetSubscriptionType } from 'types/api/backorder';
import { backOrderSubscriptionItems, backOrderSubscriptionName } from 'constants/backorder';
import Button from 'components/common/Button';

interface Props {
  subscriptionId: number;
  currentPlan: ClosetSubscriptionType;
  selectedSubscriptionType: BackOrderSubscriptionType | '';
  onChangeSubscriptionItem: (e: ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const BackOrderSelect = ({
  subscriptionId,
  currentPlan,
  selectedSubscriptionType,
  onChangeSubscriptionItem,
}: Props) => {
  const [isDownGradePlanModalOpen, setIsDownGradePlanModalOpen] = useState(false);
  const isFreePlan =
    currentPlan === ClosetSubscriptionType.FREE || currentPlan === ClosetSubscriptionType.NEW_FREE;
  const isNonSubscribablePlan =
    currentPlan === ClosetSubscriptionType.STANDARD ||
    currentPlan === ClosetSubscriptionType.PREMIUM;
  const classes = makeStyles(() =>
    createStyles({
      formControl: {
        minWidth: 180,
      },
    }),
  )();

  return (
    <>
      <FormControl className={classes.formControl}>
        <Select
          value={selectedSubscriptionType}
          onChange={onChangeSubscriptionItem}
          disabled={isNonSubscribablePlan}
          renderValue={(value: unknown) => {
            if (!value) {
              return 'Select';
            }
            return backOrderSubscriptionName[value as BackOrderSubscriptionType];
          }}
          displayEmpty
        >
          {backOrderSubscriptionItems.map(item => (
            <MenuItem key={item} value={item}>
              {backOrderSubscriptionName[item]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <DowngradeButtonWrapper>
        <Button
          variant={'contained'}
          size={'small'}
          color={'primary'}
          onClick={() => {
            setIsDownGradePlanModalOpen(true);
          }}
          disabled={isFreePlan || isNonSubscribablePlan}
        >
          Downgrade to Free Plan
        </Button>
      </DowngradeButtonWrapper>

      {isDownGradePlanModalOpen && (
        <DownGradeToFreePlanModal
          subscriptionId={subscriptionId}
          onClose={() => {
            setIsDownGradePlanModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default BackOrderSelect;

const DowngradeButtonWrapper = styled.div`
  display: inline-block;
  margin-left: 1rem;
`;
